<template>
  <div class="gift-record">
    <!-- 导航栏 -->
    <van-nav-bar
      :border="true"
      :placeholder="false"
      :fixed="true"
      ref="navBar"
      @click-left="onBack"
    >
      <template #title>
        <span class="title">礼包记录</span>
      </template>
      <template #left>
        <van-icon name="arrow-left" size=".7rem" color="#FF971C" />
      </template>
    </van-nav-bar>
    <div class="gift-wrapper">
      <div class="gift-lists">
        <div class="gift-block" v-for="(item,index) in 14" :key="index">
          <div class="L">
            <p class="title">新手礼包:</p>
            <p class="des">宝石*1,元宝*10,金币*10,美女*1,宠物*2</p>
            <p class="time">使用有效期:2020-05-27 至 2020-06-01</p>
          </div>
          <div class="R">
            <span class="copy" @click="copyCode(`uhudyed${index}`)">复制礼包码</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "recharge-record",
  components: {},
  data() {
    return {
      message: ""
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {
    onBack() {
      this.$router.go(-1);
    },
    // 复制礼包码
    async copyCode(code) {
      this.message = await code;
      let that = this;
      this.$copyText(this.message).then(
        function(e) {
          that.$toast("复制成功");
          console.log(e);
        },
        function(e) {
          that.$toast("该浏览器不支持自动复制");
          console.log(e);
        }
      );
    }
  }
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/com.less";
.gift-record {
  width: 100%;
  min-height: 100vh;
  padding-top: 46px;
  padding-bottom: 1rem;
  //  background-color: #ddd;
  .view-bg-color();
  // 导航栏
  .van-nav-bar {
    color: #fff;
    .title,
    .right {
      font-weight: bold;
      // color: #fff;
    }
  }
  // 内容
  .gift-wrapper {
    .gift-lists {
      width: 90%;
      margin: 0 auto;
      .gift-block {
        .jc-around();
        width: 100%;
        // height: 100px;
        .boxShadow(1px);
        .borderRadius(0.3rem);
        // background-color: #f00;
        margin-top: 0.5rem;
        .L {
          p {
            padding: 0.2rem 0;
            &:nth-of-type(2) {
              padding: 0;
            }
          }
          .title {
          }
          .des {
            width: 80%;
            .font-color();
            font-size: 0.4rem;
            .ellipsis();
          }
          .time {
            font-size: 0.3rem;
            .theme-color();
          }
        }
        .R {
          font-size: 0.35rem;
          .theme-bg-color();
          color: #fff;
          padding: 0.3rem 0.4rem;
          .borderRadius(0.2rem);
        }
      }
    }
  }
}
</style>